<template>
  <Header />
  <div class="inner-content aside-grid">
    <Menu />
    <div class="content-column">
      <h2 class="h2">{{ currentHelpSettings.faq_title || 'FAQ' }}</h2>

      <div v-if="faqLoading" class="table-group">
        load...
      </div>
      <div v-if="faqError" class="mc-error">{{ faqError }}</div>

      <div class="acordion-wrapper" data-mode="single">
        <div
          v-for="(item, index) in faqItems"
          :key="item.id"
          class="acordion-item"
          :class="{'acordion-item--active': activeIndex === index}"
        >
          <div class="acordion-button" @click="toggle(index)">
            <div class="acordion-item__title">{{ item[lang]?.name }}</div>
          </div>
          <div
            :ref="setBodyRef"
            class="acordion-body"
            :style="{maxHeight: activeIndex === index ? `${bodyHeights[index] || 0}px` : '0px'}"
          >
            <div class="acordion-body__content">
              <div v-html="item[lang]?.text"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Menu from "@/components/help/Menu.vue"
import Header from "@/components/help/Header.vue"

export default {
  components: {
    Menu, Header
  },
  data: () => ({
    activeIndex: 0,
    bodyRefs: [],
    bodyHeights: []
  }),
  created() {
    this.fetchFaq();
  },
  beforeUpdate() {
    this.bodyRefs = [];
  },
  updated() {
    this.updateBodyHeights();
  },
  watch: {
    faqItems() {
      this.$nextTick(this.updateBodyHeights);
    },
    lang() {
      this.$nextTick(this.updateBodyHeights);
    }
  },
  computed: {
    ...mapGetters('faq', [
      'faq',
      'faqLoading',
      'faqError',
      'faqLoaded',
    ]),
    ...mapGetters([
      'lang'
    ]),
    ...mapGetters('app', [
      'helpSettings'
    ]),
    currentHelpSettings() {
      return this.helpSettings[this.lang] || {};
    },
    faqItems() {
      return this.faq?.items || [];
    }
  },
  methods: {
    ...mapActions('faq', [
      'fetchFaq',
    ]),
    setBodyRef(element) {
      if (element) {
        this.bodyRefs.push(element);
      }
    },
    updateBodyHeights() {
      const heights = this.bodyRefs.map(element => element.scrollHeight);
      const isChanged = heights.length !== this.bodyHeights.length
        || heights.some((height, index) => height !== this.bodyHeights[index]);

      if (isChanged) {
        this.bodyHeights = heights;
      }
    },
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
      this.$nextTick(this.updateBodyHeights);
    }
  }
}
</script>
